import * as m from '@staiter/i18n';
import { ChevronRight } from 'lucide-react';
import styles from './ContextMenu.module.css';

/** Разделитель групп (макет 66:14 — обёртка с отступами 4/4 и линией 1px). */
export function ContextMenuSeparator(): JSX.Element {
  return (
    <>
      {/* biome-ignore lint/a11y/useFocusableInteractive: separator внутри role="menu" структурный — по WAI-ARIA он не участвует в обходе пунктов и фокус не принимает */}
      <div className={styles.separator} role="separator" aria-orientation="horizontal">
        <span className={styles.separatorLine} />
      </div>
    </>
  );
}

/**
 * CAPS-лейбл группы внутри подменю (макет 67:54 — StateGroup).
 *
 * D5.5 (CM-F2) — свёртываемый вариант: подпись становится переключателем и
 * прячет свою группу. Выключенные пункты архивной задачи перечислялись плоско
 * (одиннадцать строк, ни по одной нельзя кликнуть) и отодвигали доступные
 * действия вниз; свёрнутая группа оставляет от них подпись с числом.
 */
export function ContextMenuGroupLabel({
  label,
  count,
  collapsible = false,
  collapsed = false,
  active = false,
  tabbable = false,
  itemRef,
  onToggle,
}: {
  label: string;
  count?: number;
  collapsible?: boolean;
  collapsed?: boolean;
  active?: boolean;
  tabbable?: boolean;
  itemRef?: (el: HTMLButtonElement | null) => void;
  onToggle?: () => void;
}): JSX.Element {
  if (!collapsible) return <div className={styles.groupLabel}>{label}</div>;
  return (
    <button
      type="button"
      ref={itemRef}
      className={[styles.groupLabel, styles.groupLabelBtn, active ? styles.groupLabelActive : '']
        .filter(Boolean)
        .join(' ')}
      // Роль пункта меню, а не кнопки: узел участвует в обходе стрелками
      // наравне с пунктами, и AT обязан объявлять его тем же классом.
      role="menuitem"
      aria-expanded={!collapsed}
      tabIndex={tabbable ? 0 : -1}
      onClick={onToggle}
    >
      <ChevronRight
        size={16}
        aria-hidden="true"
        className={[styles.groupChevron, collapsed ? '' : styles.groupChevronOpen]
          .filter(Boolean)
          .join(' ')}
      />
      <span className={styles.groupLabelText}>{label}</span>
      {/* Раунд 2 гейта — вместо голого числа названо ДЕЙСТВИЕ. Цифра справа
          читалась как счётчик-декор, а не как «здесь можно раскрыть»; оба
          ревьюера прочли переключатель как подпись. */}
      <span className={styles.groupCount}>
        {collapsed ? m.ctx_group_show_hidden({ count: count ?? 0 }) : m.ctx_group_hide_hidden()}
      </span>
    </button>
  );
}
